import axios from "axios";

export default {
  loadRelatedMaterials({ commit, state }) {
    return new Promise((resolve, reject) => {
      for (let key of Object.keys(state.materials)) {
        if (!state.materials[key].length) {
          axios.get(`${process.env.VUE_APP_API_URL}/api/wholesale-order/items?type=opt&category_id=${key}`).then(res => {
            resolve(res.data);
            commit('updateMaterials', {
              data: res.data,
              key,
            });
          }, error => {
            reject(error)
          })
        }
      }
    })
  },

  clearRelated({ commit }) {
    commit('updateMaterial');
    commit('updateModel');
    commit('updateCount');
    commit('updateCalculation');
  },

  loadCalculation({ commit, state }) {
     return new Promise((resolve, reject) => {
      commit('updateCalculation');

      const body = {
        'total_quantity': state.count,
        'item_id': state.material.id,
        'quantity': state.count,
      };

      axios.post(`${process.env.VUE_APP_API_URL}/api/wholesale-order/opt/calculate`, body).then(res => {
        resolve(res.data);
        commit('updateCalculation', res.data);
      }, error => {
        reject(error);
        commit('updateCalculation');
      })
    })
  },
}
